import { BodyFatRiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<BodyFatRiskLevel> = new Map([
  [
    Gender.male,
    new Map([
      [BodyFatRiskLevel.Medium1, [{ lower: 4, upper: 8 }]],
      [
        BodyFatRiskLevel.Low,
        [
          {
            lower: 8,
            upper: 20,
          },
        ],
      ],
      [BodyFatRiskLevel.Medium2, [{ lower: 20, upper: 25 }]],
      [BodyFatRiskLevel.High, [{ lower: 25, upper: 90 }]],
    ]),
  ],
  [
    Gender.female,
    new Map([
      [BodyFatRiskLevel.Medium1, [{ upper: 21 }]],
      [
        BodyFatRiskLevel.Low,
        [
          {
            lower: 21,
            upper: 33,
          },
        ],
      ],
      [BodyFatRiskLevel.Medium2, [{ lower: 33, upper: 39 }]],
      [BodyFatRiskLevel.High, [{ lower: 39, upper: 90 }]],
    ]),
  ],
]);

export default referenceRange;
